import { globalEvent } from '@shared/easyfy.core';
import { GetAgeGate } from '../services/agegate.service';
import { FeatureNames, Features } from '@webServices/features.service';

export default class AgeGate {
  static Instance: AgeGate;
  constructor() {
    AgeGate.Instance = this;
    globalEvent({
      type: 'click',
      events: [
        {
          event: 'age-gate-accept',
          callback: this.acceptAgeGate,
        },
      ],
    });

    this.checkCookie();
  }

  checkCookie = () => {
    if (!this.checkIfActiveFeature()) return;

    const cookie = document.cookie
      ?.split('; ')
      ?.find((row) => row.startsWith('AgeGate'))
      ?.split('=')[1];

    if (!cookie) {
      setTimeout(() => {
        AgeGate.Instance.loadAgeGate();
      }, 5000);
    }
  };

  loadAgeGate = async () => {
    const response = await GetAgeGate();
    if (response.data?.partialHtml) document.body.insertAdjacentHTML('beforeend', response.data.partialHtml);
  };

  acceptAgeGate = () => {
    document.cookie = 'AgeGate=true';
    const ageGate: HTMLElement = document.querySelector('[data-container="age-gate"');
    if (ageGate) ageGate.remove();
  };

  checkIfActiveFeature = (): boolean => {
    return Features.FeatureIsActive(FeatureNames.AgeGate);
  };
}
